import { createWebHistory, createRouter } from "vue-router";

import modelsList from "./components/pages/models/list";
import modelView from "./components/pages/models/view";
import beaModel from "./components/pages/be-a-model";
import contacts from "./components/pages/contacts";
import privacy from "./components/pages/privacy";
import tos from "./components/pages/tos";
import pageNotFound from "./components/pages/404";

const pathWithLocale = path => {
  return `/:locale(ru|en)?${path}`;
};

const routes = [
  {
    path: pathWithLocale("/"),
    name: "models",
    component: modelsList,
  },
  {
    path: pathWithLocale("/models/:model([\\w\\d\\-\\_]+)"),
    name: "models-view",
    component: modelView,
  },
  {
    path: pathWithLocale("/be-a-model"),
    name: "be-a-model",
    component: beaModel,
  },
  {
    path: pathWithLocale("/contacts"),
    name: "contacts",
    component: contacts,
  },
  {
    path: pathWithLocale("/privacy"),
    name: "privacy",
    component: privacy,
  },
  {
    path: pathWithLocale("/tos"),
    name: "tos",
    component: tos,
  },
  {
    path: "/:pathMatch(.*)",
    name: "page-not-found",
    component: pageNotFound,
  },
];

export default createRouter({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ?? { x: 0, y: 0 };
  },
  history: createWebHistory(),
  routes,
});
